<template>
  <div
    v-clickOutSide="handleClose"
    :class="['fddform-input', 'fddform-select', { 'fddform-select-arrow': visible }]"
    @click.stop="showOption"
  >
    <input
      ref="input"
      type="text"
      readonly
      class="input"
      :class="inputClass"
      :placeholder="placeholder"
      unselectable="on"
    />
    <label class="use-down"></label>
    <ul v-show="visible" ref="preview" class="fddform-input-list" :style="{ top: top + 'px' }">
      <slot>
        <li class="text-center">{{ emptyText }}</li>
      </slot>
    </ul>
  </div>
</template>
<script>
  import ClickOutSide from '../../utils/clickoutside'

  export default {
    name: 'FddSelect',
    directives: { ClickOutSide },
    props: {
      top: {
        type: Number,
        default: 30
      },
      placeholder: {
        type: String,
        default: '请选择'
      },

      // eslint-disable-next-line vue/require-prop-types
      value: {},
      inputClass: {
        type: [Array, Object, String],
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        children: []
      }
    },
    provide() {
      return {
        select: this
      }
    },
    computed: {
      emptyText() {
        return this.children.length <= 0 && '无数据'
      }
    },
    watch: {
      value(val) {
        let selected = this.children.find(item => item.value === val)
        let label = selected ? selected.currentLabel : ''

        this.$refs.input.value = label
      },

      // 下拉框出现/隐藏
      visible(val, old) {
        this.$emit('visible-change', val)
      }
    },
    methods: {
      showOption(e) {
        this.visible = !this.visible
      },
      handleClose() {
        this.visible = false
      }
    }
  }
</script>
